// @ts-ignore - Prisma client types
import type {  User  } from '@prisma/client';
// @ts-ignore - Prisma runtime types
import type { JsonValue } from '@prisma/client/runtime/library';
import { UserType } from "@/types/user";

export type ExtendedUser = Required<UserType>;

// Helper function to ensure user objects have encryption fields
export function ensureExtendedUser(user: User | ExtendedUser | UserType | null): ExtendedUser {
  if (!user) {
    // Return a default ExtendedUser if null
    return {
      id: '-1',
      name: '',
      email: '',
      emailVerified: null,
      image: null,
      username: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      following: [],
      followers: [],
      hashedPassword: '',
      bio: '',
      bioLink: null,
      profileURL: null,
      emailVerificationToken: null,
      emailVerificationTokenExpiry: null,
      passwordResetToken: null,
      passwordResetTokenExpiry: null,
      suspended: false,
      notifications: [],
      conversations: [],
      posts: [],
      publicKey: null,
      privateKey: null,
      encryptionKey: null,
      encryptedData: null,
    };
  }
  
  // Convert User to ExtendedUser
  return {
    ...user,
    following: Array.isArray(user.following) ? user.following : [],
    followers: Array.isArray(user.followers) ? user.followers : [],
    notifications: Array.isArray((user as any).notifications) ? (user as any).notifications : [],
    conversations: Array.isArray((user as any).conversations) ? (user as any).conversations : [],
    bio: (user as any).bio || '',
    bioLink: (user as any).bioLink || null,
    profileURL: (user as any).profileURL || null,
    hashedPassword: (user as any).hashedPassword || '',
    emailVerificationToken: (user as any).emailVerificationToken || null,
    emailVerificationTokenExpiry: (user as any).emailVerificationTokenExpiry || null,
    passwordResetToken: (user as any).passwordResetToken || null,
    passwordResetTokenExpiry: (user as any).passwordResetTokenExpiry || null,
    suspended: (user as any).suspended || false,
    posts: Array.isArray((user as any).posts) ? (user as any).posts : [],
    publicKey: (user as any).publicKey || null,
    privateKey: (user as any).privateKey || null,
    encryptionKey: (user as any).encryptionKey || null,
    encryptedData: (user as any).encryptedData || null,
  } as ExtendedUser;
}
